// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__ljrA5","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1jRrG","obliqueLine":"membershipbadge_obliqueLine__1n6gS"};